import { Divider, Group, Stack, createStyles, useMantineTheme } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';
import dt from '~/testing';

import type { BaseInterativeField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type SummaryItemsType = BaseInterativeField & {
  type: 'SummaryItems';
  options: { name: string | undefined; value: string | number; sublabel?: string }[];
  noDataMessage?: string;
};

const useStyles = createStyles((theme) => ({
  card: {
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    position: 'relative',
  },
  justify: {
    justifyContent: 'space-between',
  },
}));

function SummaryItemsElement({ field }: StaticFieldProps<SummaryItemsType>) {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  return (
    <>
      <Divider /* eslint-disable-line local-rules/use-theme-tokens */ mb={10} />
      <Stack className={classes.card} spacing={theme.other.spacing._8}>
        {field.options?.length ? (
          field.options.map((option) => (
            <Group
              data-test-id={dt.contest.create.summaryItem}
              key={option.value}
              className={classes.justify}
              spacing={theme.other.spacing._2}
              align="baseline"
            >
              {option.name ? <Text variant="title-small">{option.name}:</Text> : null}
              <Text
                variant="title-small"
                c={theme.colors.gray[6]}
                dangerouslySetInnerHTML={option.value ? { __html: option.value } : undefined}
              >
                {option?.sublabel ? (
                  <Text variant="title-small" c={theme.colors.gray[6]}>
                    {' '}
                    {option.sublabel}
                  </Text>
                ) : null}
              </Text>
            </Group>
          ))
        ) : (
          <Text variant="body-medium" ta="center">
            {field?.noDataMessage ?? 'No data'}
          </Text>
        )}
      </Stack>
    </>
  );
}

const Descriptor: FieldDescriptor<SummaryItemsType> = {
  FieldComponent: SummaryItemsElement,
  name: 'SummaryItems',
};

export default Descriptor;
